import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  Zoom,
  useMediaQuery,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import InputMask from 'react-input-mask';
import { ApiService } from 'app/servicesTwo/ApiService';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { updateInputValue } from '../../../utils/appHelpers';
import { useJumboDialog } from '@jumbo/components/JumboDialog/hooks/useJumboDialog';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Div from '@jumbo/shared/Div';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
/* import ClassStudentsList from "./ClassStudentsList"; */
import HeaderBreadcrumbs from 'app/layouts/shared/headers/HeaderBreadcrumbs/HeaderBreadcrumbs';
import { PermissionContext } from 'app/contexts/PermissionContext';
import UploadIcon from '@mui/icons-material/Upload';
import ListRowVolunteerInterested from 'app/components/ListRowVolunteerInterested/ListRowVolunteerInterested';
import makeAnimated from 'react-select/animated';
import BadgeCard from 'app/components/BadgeCard/BadgeCard';
import { generateBadgeCardPdf } from 'app/utils/BadgeUtils';
import BadgeIcon from '@mui/icons-material/Badge';
import JumboSearchClasses from '@jumbo/components/JumboSearchClasses';
import { useDebouncedCallback } from 'beautiful-react-hooks';
import styled from '@emotion/styled';
import FileListSlim from 'app/components/FileUploadSlim/FileListSlim';
import DeleteIcon from '@mui/icons-material/Delete';
import ProfileCard from 'app/components/ProfileCard/ProfileCard';
import PhotoCropModal from 'app/components/PhotoCropModal/PhotoCropModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const FileListItem = styled.li`
  list-style: none;
  /* margin: 1rem 0; */
  background-color: rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.9rem;
`;

const VolunteerFormResume = () => {
  const { theme } = useJumboTheme();
  const navigate = useNavigate();
  const Swal = useSwalWrapper();
  const toast = (variant, message, type = false) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true,
      closeButtonAriaLabel: 'Fechar',
    });
  };

  const lg = useMediaQuery(theme.breakpoints.down('lg'));
  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: 'flex-start',
        },
      },
    }),
    [theme]
  );

  const initialValues = {
    pessoa_id: '',
    voluntario_id: '',
    codigo_antigo_voluntariado: '',
    codigo_voluntario_feesp: '',
    nome_cracha: '',
    foto_cracha: '',
    status: '',
    data_inicio: '',
    data_fim: '',
    departamento_id: '',
    area_id: '',
    local: '',
    ficha: '',
    atividade: '',
    observacao: '',
    voluntario_desde: '',
    motivo_encerramento: null,
    obs_encerramento: null,
    teve_vivencia_pratica: false,
    quais_trabalhos: false,
    confirmar_voluntariado: false,
    encerrar_voluntariado: false,
  };

  const validationSchema = yup.object().shape({
    departamento_id: yup.number().nullable(),
    area_id: yup.number().required('Preenchimento obrigatório'),
    local: yup.string().required('Preenchimento obrigatório'),
  });

  const { id } = useParams();

  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const [users, setUsers] = useState(initialValues);
  const [addStudents, setAddStudents] = useState(null);
  const [classStudents, setClassStudents] = useState([]);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [userFile, setUserFile] = useState(null);
  const [badgePhoto, setBadgePhoto] = useState(null);
  const [badgePhotoPreview, setBadgePhotoPreview] = useState(null);
  const [status, setStatus] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userVolunteerCourse, setUserVolunteerCourse] = useState(false);
  const [verifyVolunteerCourse, setVerifyVolunteerCourse] = useState({});
  const [username, setUsername] = useState('');
  const [departments, setDepartments] = useState([]);
  const [areas, setAreas] = useState([]);
  const [activities, setActivities] = useState([]);
  const [activitiesSelected, setActivitiesSelected] = useState(null);
  const [editInput, setEditInput] = useState(true);

  const [badgeLayout, setBadgeLayout] = useState('vertical');
  const [generatingBadge, setGeneratingBadge] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentPhotoUrl, setCurrentPhotoUrl] = useState(null);
  const [originalBadgePhoto, setOriginalBadgePhoto] = useState(null); // Guarda a foto ORIGINAL do servidor
  const [originalBadgePhotoUrl, setOriginalBadgePhotoUrl] = useState(null); // URL da foto ORIGINAL

  const [userPreferences, setUserPreferences] = useState([
    { dia_da_semana: '', horario_inicio: '', horario_fim: '' },
  ]);
  const [deletedPreferences, setDeletedPreferences] = useState([]);

  const [userVolunteerOut, setUserVolunteerOut] = useState([
    {
      nome_trabalho_voluntario_fora: '',
      local_fora: '',
      data_inicio_voluntario_fora: '',
      obs_fora: '',
    },
  ]);
  const [deletedVolunteerOut, setDeletedVolunteerOut] = useState([]);
  const [open, setOpen] = useState(false);

  const [files, setFiles] = useState([]);
  const [filesSelected, setFilesSelected] = useState([]);
  const [isEditingFile, setIsEditingFile] = useState(false);
  const [textFile, setTextFile] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { hasPermission } = useContext(PermissionContext);
  let { state } = useLocation();

  const canCreate = hasPermission('Voluntariado', 'criar');
  const canEdit = hasPermission('Voluntariado', 'editar');
  const isDisabled = id ? !canEdit : !canCreate;

  const isInputEditable = editInput === true;
  const isStatusDisabled = status === false;

  const storedUserId = localStorage.getItem('storedUserId');

  const getCourseById = useCallback(async (voluntario_id) => {
    console.log(selectedOption);
    console.log(users);
    try {
      ApiService.get(`/voluntarios/${id || voluntario_id}`)
        .then((response) => {
          console.log('iii', response.data);
          setUsers({
            ...response.data,
            quais_trabalhos: false,
            is_codigo_voluntario_feesp_exists: response.data
              ?.codigo_voluntario_feesp
              ? true
              : false,
          });

          // Guarda a foto original do servidor
          let originalPhotoUrl = null;
          if (response.data.foto_cracha) {
            originalPhotoUrl = `${process.env.REACT_APP_API_KEY}/images/${response.data.foto_cracha}`;
            setOriginalBadgePhoto(response.data.foto_cracha); // Nome do arquivo original
            setOriginalBadgePhotoUrl(originalPhotoUrl); // URL completa da original
          } else if (response.data.User && response.data.User.imagem_perfil) {
            originalPhotoUrl = `${process.env.REACT_APP_API_KEY}/images/${response.data.User.imagem_perfil}`;
            setOriginalBadgePhoto(response.data.User.imagem_perfil);
            setOriginalBadgePhotoUrl(originalPhotoUrl);
          }

          // Define o preview inicial (pode ser a cropada se existir, senão usa a original)
          if (response.data.foto_cracha) {
            setBadgePhotoPreview(
              `${process.env.REACT_APP_API_KEY}/images/${response.data.foto_cracha}`
            );
          } else if (response.data.User && response.data.User.imagem_perfil) {
            setBadgePhotoPreview(
              `${process.env.REACT_APP_API_KEY}/images/${response.data.User.imagem_perfil}`
            );
          }

          setSelectedOption(response.data.User);
          setUserPreferences(response.data.Horario_voluntariado);
          setUserVolunteerOut(response.data.Trabalho_Voluntario_Fora_Feesp);
          setActivitiesSelected(response.data.atividade_selecionada_id);

          if (response.data.status == 'ativo') {
            setStatus(true);
          }
          //setVerifyVolunteerCourse(response.data.verifyVolunteerCourse)
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getDepartments = useCallback(async () => {
    try {
      ApiService.get(`/departamentos`)
        .then((response) => {
          setDepartments(response.data);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getAreas = useCallback(async () => {
    try {
      ApiService.get(`/areas`)
        .then((response) => {
          setAreas(response.data);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getAtividades = useCallback(async () => {
    try {
      ApiService.get(`/atividades-voluntarios`)
        .then((response) => {
          console.log(response.data);
          setActivities(response.data);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getCourseById(selectedOption, userVolunteerCourse);
      getAtividades();
    }
    getDepartments();
    getAreas();
    getAtividades();
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let volunteerId;
    let formData = new FormData();

    filesSelected.forEach((file, index) => {
      if (file instanceof File) {
        formData.append('docs', file);
        formData.append(`nome_label_${index}`, file.nome_label);
      }
    });

    if (id || users.is_codigo_voluntario_feesp_exists) {
      if (values.encerrar_voluntariado == 'on') {
        // ── ENCERRAR VOLUNTARIADO ──────────────────────────────────────────
        const result = await Swal.fire({
          title: 'Tem certeza que deseja encerrar voluntariado?',
          text: 'Não será possível reverter a ação!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não!',
          reverseButtons: true,
        });

        if (result.value) {
          await ApiService.put(`/encerrar-voluntariado/${id}`, { values })
            .then(() => toast('success', 'Voluntario encerrado com sucesso'))
            .catch((error) => {
              toast('error', 'Ocorreu um erro');
              console.log(error);
            });
        }
      } else {
        // ── ATUALIZAR 
        const allValuesEdit = {
          ...values,
          horario_voluntariado: userPreferences,
          trabalho_voluntario_fora_feesp: userVolunteerOut,
          atividade_selecionada_id: activitiesSelected,
        };

        for (const key in allValuesEdit) {
          if (allValuesEdit.hasOwnProperty(key)) {
            if (
              typeof allValuesEdit[key] === 'object' &&
              allValuesEdit[key] !== null
            ) {
              formData.append(key, JSON.stringify(allValuesEdit[key]));
            } else {
              formData.append(key, allValuesEdit[key]);
            }
          }
        }
      }

      if (badgePhoto) {
        // foto_cracha → atualiza o crachá do voluntário
        formData.append('foto_cracha', badgePhoto);
        // imagem_perfil → atualiza também o cadastro de Pessoa
        formData.append('imagem_perfil', badgePhoto);
      }

      await ApiService.put(
        `/voluntarios/${id || users.voluntario_id}?page=voluntario`,
        formData
      )
        .then(async () => {
          // ── Salva declarações novas junto com o Atualizar ──────────────
          if (filesSelected.length > 0) {
            try {
              let docsFormData = new FormData();
              filesSelected.forEach((file, index) => {
                if (file instanceof File) {
                  docsFormData.append('docs', file);
                  docsFormData.append(`nome_label_${index}`, file.nome_label);
                }
              });
              docsFormData.append('voluntario_id', id || users.voluntario_id);

              //await ApiService.post(`/fichas-do-voluntario`, docsFormData);

              setFiles([]);
              setFilesSelected([]);
              setTextFile(null);
              toast(
                'success',
                'Voluntário e declarações atualizados com sucesso'
              );
              getCourseById(id || users.voluntario_id);
            } catch (err) {
              console.log(err);
              toast(
                'error',
                'Voluntário atualizado, mas erro ao salvar declarações'
              );
            }
          } else {
            if (!userFile)
              toast('success', 'Voluntário atualizado com sucesso');
          }

          // ── Salva ficha (PDF avulso) se houver ─────────────────────────
          if (userFile) {
            let data = new FormData();
            data.append('ficha', userFile);
            ApiService.put(
              `/voluntarios/atualizar-ficha/${id || users.voluntario_id}`,
              data
            )
              .then(() =>
                toast('success', 'Voluntário atualizado com sucesso', true)
              )
              .catch((error) => {
                console.log(error);
                toast('error', 'Ocorreu um erro ao enviar a ficha', true);
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            const err = error.response.data;
            if (err.pertenceA) {
              Swal.fire({
                icon: 'error',
                title: 'Código já existe!',
                html: `
                  <p><b>${err.error}</b></p>
                  <p>Este código pertence a:</p>
                  <p><b>${err.pertenceA.nome}</b> (ID: ${err.pertenceA.id})</p>
                `,
                confirmButtonText: 'Entendi',
              });
            } else {
              toast('error', err.error || 'Ocorreu um erro');
            }
            console.log(error.response.data);
            console.log(error.response.status);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    } else {
      // ── CADASTRAR ─────────────────────────────────────────────────────────
      const allValues = {
        ...values,
        pessoa_id: username.pessoa_id,
        id_quem_aceitou: storedUserId,
        atividade_selecionada_id: activitiesSelected,
      };

      for (const key in allValues) {
        if (allValues.hasOwnProperty(key)) {
          formData.append(key, allValues[key]);
        }
      }

      if (badgePhoto) {
        formData.append('foto_cracha', badgePhoto);
        // imagem_perfil → atualiza também o cadastro de Pessoa
        formData.append('imagem_perfil', badgePhoto);
      }

      await ApiService.post('/voluntarios?page=voluntario', formData)
        .then((response) => {
          volunteerId = response.data[0].voluntario_id;
          setUsers(response.data[0]);
          toast('success', 'Criado com sucesso');
          setSubmitClicked(true);

          setFiles([]);
          setFilesSelected([]);
          setTextFile(null);

          //getCourseById(volunteerId);
        })
        .catch((error) => {
          if (error.response) {
            const err = error.response.data;
            if (err.pertenceA) {
              Swal.fire({
                icon: 'error',
                title: 'Código já existe!',
                html: `
                  <p><b>${err.error}</b></p>
                  <p>Este código pertence a:</p>
                  <p><b>${err.pertenceA.nome}</b> (ID: ${err.pertenceA.id})</p>
                `,
                confirmButtonText: 'Entendi',
              });
            } else {
              toast('error', err.error || 'Ocorreu um erro');
            }
            console.log(error.response.data);
            console.log(error.response.status);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    }

    setSubmitting(false);
  };

  const uploadHandler = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setFiles([...files, file]);
    setFilesSelected([...filesSelected, file]);
  };

  const removeFile = (index) => {
    setFiles(files.filter((file, i) => i !== index));
  };

  const handleSaveClick = (index) => {
    setIsEditingFile(false);
    files.map((file, i) =>
      i == index ? (file.nome_label = textFile) : file.nome_label
    );
    setTextFile('');
  };

  const handleEditClick = (index) => {
    setIsEditingFile({ active: true, index: index });
    setTextFile(
      files
        .filter(
          (file, i) =>
            i === index &&
            (file.nome_label || file.nome || file instanceof File)
        )
        .map((file) => {
          if (file instanceof File && file.nome_label) {
            return file.nome_label;
          }
          return file.nome_label || file.nome || file.name;
        })
    );
  };

  const handleInputChangeFile = (e) => {
    setTextFile(e.target.value);
  };

  const uploadFile = async (voluntario_id) => {
    let formData = new FormData();
    filesSelected.forEach((file, index) => {
      if (file instanceof File) {
        formData.append('docs', file);
        formData.append(`nome_label_${index}`, file.nome_label);
      }
    });

    if (files.length > 0) {
      formData.append('voluntario_id', users.voluntario_id); // Adiciona o pessoa_id

      ApiService.post(`/fichas-do-voluntario`, formData)
        .then(() => {
          setFiles([]);
          setFilesSelected([]);
          setTextFile(null);
          getCourseById(voluntario_id);
          toast('success', 'Adicionado com sucesso');
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
        });
    }
  };

  const modalAlertDeleteFile = (id, voluntario_id) => {
    console.log(id);
    Swal.fire({
      title: 'Tem certeza que deseja apagar?',
      text: 'Não será póssível reverter a ação!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim!',
      cancelButtonText: 'Não!',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        removeFileFromBd(id, voluntario_id);
      }
    });
  };

  const removeFileFromBd = async (id, voluntario_id) => {
    ApiService.delete(`/fichas-do-voluntario/${id}`)
      .then(() => {
        /* setFiles([]);
        setFilesSelected([]);
        setTextFile(null); */
        getCourseById(voluntario_id);
        toast('success', 'Removido com sucesso');
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('error', error.message);
        }
      });
  };

  useEffect(() => {
    if (searchTerm == undefined || searchTerm == '') {
      setAddStudents(null);
      return;
    }

    const delayDebounceFn = setTimeout(() => {
      searchStudent(searchTerm);
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const searchStudent = useCallback(async (e) => {
    setLoading(true);
    try {
      ApiService.get(`/pessoa`, { params: { search: e, turma_id: id } })
        .then((response) => {
          setAddStudents(response.data);
          // toast('success', 'Aluno adicionado com sucesso');
          setLoading(false);
        })
        .catch((error) => {
          // toast('error', 'Ocorreu um erro');

          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('error', error.message);
          }
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChangeSearch = useDebouncedCallback((event) => {
    setSearchTerm(event.target.value);
  });

  React.useEffect(() => {
    setSearchTerm(searchTerm);
  }, [searchTerm]);

  React.useEffect(() => {
    return () => handleChangeSearch.cancel();
  });

  const updateStudentList = useCallback(async (data) => {
    setClassStudents([...data]);
    setAddStudents(null);
  }, []);

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  const [submitClicked, setSubmitClicked] = useState(false);

  return (
    <JumboContentLayout
      header={
        <HeaderBreadcrumbs
          id={id}
          title={'Voluntários'}
          subtitle={id ? 'Editar' : 'Cadastro de Voluntariado'}
          titleUrl={'/app/listar-voluntariado'}
        />
      }
      layoutOptions={layoutOptions}
    >
      {lg && (
        <Stack spacing={2} direction={'row'} sx={{ mb: 3, mt: -2 }}></Stack>
      )}

      <Paper sx={{ p: '40px' }}>
        {state && (
          <Button
            color='success'
            type='submit'
            variant='contained'
            size='large'
            sx={{ maxWidth: { md: '200px' }, mb: '2rem' }}
            onClick={() => navigate(state.backUrl)}
          >
            Voltar
          </Button>
        )}
        <Formik
          initialValues={users}
          //validationSchema={validationSchema}
          enableReinitialize
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={handleSubmit}
        >
          {({ values, isSubmitting, handleChange }) => {
            const selectedArea = areas.find(
              (area) => area.area_id === values.area_id
            );

            /* if(username && (username.ficha !== null  || username.ficha !== undefined)) {
                        values.ficha = username.ficha
                    } */
            return (
              <Form style={{ width: '100%' }} noValidate autoComplete='off'>
                <Grid container spacing={3} alignContent={'center'}>
                  {id ? null : (
                    <>
                      <Grid item xs={12}>
                        <JumboSearchClasses
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder='Busque por Nome, CPF ou E-mail.'
                          sx={{
                            width: '440px',
                            marginBottom: '1rem',
                          }}
                          onFocus={handleInputFocus}
                          onBlur={handleInputBlur}
                          disabled={isDisabled}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        {loading && (
                          <Box display='flex' justifyContent='center'>
                            <CircularProgress />
                          </Box>
                        )}
                        {addStudents != null && addStudents.length > 0 && (
                          <ListRowVolunteerInterested
                            data={addStudents}
                            updateStudentList={(data) =>
                              updateStudentList(data)
                            }
                            classStudents={classStudents}
                            status={status}
                            setStatus={setStatus}
                            setUsername={setUsername}
                            setSearchTerm={setSearchTerm}
                            setUsers={setUsers}
                            setBadgePhotoPreview={setBadgePhotoPreview}
                          />
                        )}
                        {addStudents != null && addStudents.length == 0 && (
                          <Typography>
                            Sem resultados correspondentes
                          </Typography>
                        )}
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12}>
                    <Typography variant='h4'>Dados do Voluntário</Typography>
                  </Grid>

                  {/* <Grid item xs={12} sm={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                         <div style={{ 
                             width: '100px', 
                             height: '100px', 
                             borderRadius: '50%', 
                             overflow: 'hidden', 
                             marginBottom: '8px',
                             border: '1px solid #ccc',
                             backgroundImage: `url(${badgePhotoPreview || 'https://via.placeholder.com/100'})`,
                             backgroundSize: 'cover',
                             backgroundPosition: 'center'
                         }} />
                         <Button
                            variant="outlined"
                            component="label"
                            size="small"
                            disabled={isDisabled || (!id && !username)}
                         >
                            Alterar Foto
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={(e) => {
                                    if (e.target.files && e.target.files[0]) {
                                        setBadgePhoto(e.target.files[0]);
                                        setBadgePhotoPreview(URL.createObjectURL(e.target.files[0]));
                                    }
                                }}
                            />
                         </Button>
                  </Grid> */}
                  <Grid item xs={5}>
                    <JumboTextField
                      fullWidth
                      name={id ? 'voluntario_id' : 'pessoa_id'}
                      label='Nome'
                      value={
                        id
                          ? selectedOption && selectedOption.nome
                          : username && username.nome
                      }
                      disabled={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={5}>
                    <JumboTextField
                      fullWidth
                      name='nome_cracha'
                      label='Nome para crachá'
                      placeholder='Digite o nome para o crachá'
                      value={updateInputValue(users, values, 'nome_cracha')}
                      onChange={handleChange}
                      inputProps={{ maxLength: 32 }}
                      helperText='Máx. 32 caracteres'
                      sx={{ background: '#ffffff' }}
                      disabled={isDisabled || (!id && !username)}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <InputMask
                      mask='99/9999'
                      value={updateInputValue(
                        users,
                        values,
                        'voluntario_desde'
                      )}
                      onChange={handleChange}
                      disabled={isDisabled || status == false}
                      disableUnderline={isDisabled || status == false}
                      placeholder='mm/aaaa'
                    >
                      {(inputProps) => (
                        <JumboTextField
                          {...inputProps}
                          id='voluntario_desde'
                          fullWidth
                          name='voluntario_desde'
                          label='Voluntário desde'
                          type='text'
                          sx={{ background: '#ffffff' }}
                          disabled={inputProps.disableUnderline}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid item xs={4}>
                    <JumboTextField
                      fullWidth
                      name='codigo_unificado'
                      label='Código de voluntário'
                      value={
                        (values.codigo_antigo_voluntariado ||
                          values.codigo_voluntario_feesp) ??
                        ''
                      }
                      placeholder=' Informe o código utilizado na Assistência Espiritual'
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!val) {
                          handleChange({
                            target: {
                              name: 'codigo_voluntario_feesp',
                              value: '',
                            },
                          });
                          handleChange({
                            target: {
                              name: 'codigo_antigo_voluntariado',
                              value: '',
                            },
                          });
                        } else if (/^\d+$/.test(val)) {
                          handleChange({
                            target: {
                              name: 'codigo_voluntario_feesp',
                              value: val,
                            },
                          });
                          handleChange({
                            target: {
                              name: 'codigo_antigo_voluntariado',
                              value: '',
                            },
                          });
                        } else {
                          handleChange({
                            target: {
                              name: 'codigo_antigo_voluntariado',
                              value: val,
                            },
                          });
                          handleChange({
                            target: {
                              name: 'codigo_voluntario_feesp',
                              value: '',
                            },
                          });
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Typography variant='caption' color='textSecondary'>
                      Caso não possua, deixar em branco pois o sistema gerará um
                      novo código;
                    </Typography>
                  </Grid>

                  <Grid item xs={4} sx={{ display: 'none' }}>
                    <FormControlLabel
                      name={updateInputValue(
                        users,
                        values,
                        'teve_vivencia_pratica'
                      )}
                      control={
                        <Checkbox
                          name='teve_vivencia_pratica'
                          checked={updateInputValue(
                            users,
                            values,
                            'teve_vivencia_pratica'
                          )}
                          disabled={isDisabled || status == false}
                        />
                      }
                      label='Realizou curso de Capacitação de Voluntários?'
                      labelPlacement='end'
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* ── DECLARAÇÕES (esquerda) + CRACHÁ (direita) ── */}
                  <Grid item xs={12} sm={6}>
                    {/* Título */}
                    <Typography mb={1}>Declarações/Comprovantes</Typography>

                    {/* Arquivos já salvos no servidor */}
                    <Box
                      display={'flex'}
                      flexWrap={'wrap'}
                      gap={1}
                      flexDirection={'column'}
                      mb={2}
                    >
                      {users?.Ficha_Do_Voluntario?.map((item) => (
                        <FileListItem className='file-item' key={item.nome}>
                          <p>
                            <a
                              href={`${process.env.REACT_APP_API_KEY}/images/${item.nome}`}
                              target='_blank'
                              rel='noreferrer'
                            >
                              {item?.nome_label ||
                                item?.nome.replace(/^\d+_/, '')}
                            </a>
                          </p>
                          <Button
                            variant='contained'
                            size='small'
                            color='secondary'
                            onClick={() =>
                              modalAlertDeleteFile(
                                item.ficha_do_voluntario_id,
                                item.voluntario_id
                              )
                            }
                            disabled={!id}
                          >
                            <DeleteIcon />
                          </Button>
                        </FileListItem>
                      ))}
                    </Box>

                    {/* Arquivos novos ainda não salvos */}
                    <FileListSlim
                      files={files}
                      removeFile={removeFile}
                      isEditingFile={isEditingFile}
                      textFile={textFile}
                      handleInputChangeFile={handleInputChangeFile}
                      handleSaveClick={handleSaveClick}
                      handleEditClick={handleEditClick}
                      setIsEditingFile={setIsEditingFile}
                    />

                    {/* Botão adicionar — texto atualizado */}
                    <Button
                      variant='contained'
                      component='label'
                      color='info'
                      disabled={isDisabled || status == false}
                      sx={{
                        height: '53.13px',
                        fontSize: { xs: '0.7rem' },
                        textAlign: 'center',
                        mb: 2,
                      }}
                    >
                      CLIQUE AQUI para cada documento
                      <input
                        type='file'
                        hidden
                        name='imagem_area'
                        onChange={uploadHandler}
                      />
                    </Button>

                    
                  </Grid>

                  {/* ── CRACHÁ (direita) ── */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    display='flex'
                    justifyContent='center'
                    alignItems='flex-start'
                  >
                    {(() => {
                      console.log({values})
                      console.log({badgePhoto})
                      const badgeUser = id
                        ? {
                            ...(users.person ? users.person : users),
                            nome_cracha: values.nome_cracha,
                            foto_cracha: badgePhoto || values.foto_cracha,
                            codigo_voluntario_feesp:
                              values.codigo_voluntario_feesp,
                            codigo_antigo_voluntariado:
                              values.codigo_antigo_voluntariado,
                            User: {
                              ...(users.person
                                ? users.person.User
                                : users.User),
                            },
                          }
                        : username
                        ? {
                            ...username,
                            nome_cracha: values.nome_cracha,
                            foto_cracha: badgePhoto || values.foto_cracha,
                            codigo_voluntario_feesp:
                              values.codigo_voluntario_feesp,
                            codigo_antigo_voluntariado:
                              values.codigo_antigo_voluntariado,
                            User: {
                              ...username.User,
                              nome: username.User?.nome || username.nome,
                            },
                          }
                        : null;

                      if (!badgeUser) return null;

                      const handleCropSave = (croppedFile) => {
                        setBadgePhoto(croppedFile);
                        setBadgePhotoPreview(URL.createObjectURL(croppedFile));
                        setCropModalOpen(false);
                        setCurrentPhotoUrl(null);
                      };

                      const handleOpenCropModal = () => {
                        if (originalBadgePhotoUrl) {
                          setCurrentPhotoUrl(originalBadgePhotoUrl);
                          setCropModalOpen(true);
                        }
                      };

                      const handleChangePhoto = () => {
                        if (!isDisabled) fileInputRef.current?.click();
                      };

                      const handleFileSelect = (e) => {
                        if (e.target.files && e.target.files[0]) {
                          const file = e.target.files[0];
                          const photoUrl = URL.createObjectURL(file);
                          setOriginalBadgePhoto(file);
                          setOriginalBadgePhotoUrl(photoUrl);
                          setBadgePhoto(file);
                          setBadgePhotoPreview(photoUrl);
                          setCurrentPhotoUrl(photoUrl);
                          setCropModalOpen(true);
                        }
                      };

                      const handleGerarCracha = async () => {
                        setGeneratingBadge(true);
                        try {
                          await generateBadgeCardPdf(badgeUser, badgeLayout);
                        } finally {
                          setGeneratingBadge(false);
                        }
                      };

                      return (
                        <Paper
                          variant='outlined'
                          sx={{
                            p: 2.5,
                            borderRadius: 3,
                            width: '100%',
                            maxWidth: badgeLayout === 'horizontal' ? 400 : 320,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <Typography variant='subtitle1' fontWeight={600}>
                              Crachá
                            </Typography>
                            <ToggleButtonGroup
                              value={badgeLayout}
                              exclusive
                              size='small'
                              onChange={(e, value) =>
                                value && setBadgeLayout(value)
                              }
                            >
                              <ToggleButton value='vertical'>
                                Vertical
                              </ToggleButton>
                              <ToggleButton value='horizontal'>
                                Horizontal
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Box>

                          <Box>
                            <BadgeCard
                              user={badgeUser}
                              onChangePhoto={handleChangePhoto}
                              onCropPhoto={handleOpenCropModal}
                              originalPhotoUrl={originalBadgePhotoUrl}
                              layout={badgeLayout}
                            />
                            <input
                              type='file'
                              hidden
                              ref={fileInputRef}
                              accept='image/*'
                              onChange={handleFileSelect}
                            />
                          </Box>

                          <LoadingButton
                            fullWidth
                            variant='contained'
                            color='primary'
                            startIcon={<BadgeIcon />}
                            loading={generatingBadge}
                            onClick={handleGerarCracha}
                          >
                            Gerar Crachá
                          </LoadingButton>

                          {currentPhotoUrl && (
                            <PhotoCropModal
                              open={cropModalOpen}
                              onClose={() => {
                                setCropModalOpen(false);
                                setCurrentPhotoUrl(null);
                              }}
                              imageUrl={currentPhotoUrl}
                              onSave={handleCropSave}
                            />
                          )}
                        </Paper>
                      );
                    })()}
                  </Grid>

                  {/* ── BOTÃO ATUALIZAR / CADASTRAR ── */}
                  <Grid item xs={12} sx={{ textAlign: 'center', mt: 3 }}>
                    <LoadingButton
                      color='success'
                      type='submit'
                      variant='contained'
                      size='large'
                      sx={{ maxWidth: { md: '200px', mt: '1rem' } }}
                      loading={isSubmitting}
                      disabled={
                        isDisabled ||
                        isInputFocused /* ||
                        (isInputEditable ? isStatusDisabled : false) ||
                        submitClicked */
                      }
                    >
                      {id ? 'Atualizar' : 'Cadastrar'}
                    </LoadingButton>
                  </Grid>

                  {/* <>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink id='area_id'>
                          Área
                        </InputLabel>
                        <JumboSelectField
                          labelId='area_id'
                          id='area_id'
                          name='area_id'
                          value={updateInputValue(users, values, 'area_id')}
                          label='Área'
                          disabled={isDisabled || status == false}
                          notched
                        >
                          <MenuItem value={''}>Sem seleção</MenuItem>
                          {areas.length > 0 &&
                            areas.map((x) => (
                              <MenuItem value={x.area_id}>{x.nome}</MenuItem>
                            ))}
                        </JumboSelectField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink id='departamento_id'>
                          Departamento
                        </InputLabel>
                        <JumboSelectField
                          labelId='departamento_id'
                          id='departamento_id'
                          name='departamento_id'
                          value={updateInputValue(
                            users,
                            values,
                            'departamento_id'
                          )}
                          label='Departamento'
                          disabled={isDisabled || status == false}
                          sx={{ background: '#ffffff' }}
                          notched
                        >
                          <MenuItem value={''}>Sem seleção</MenuItem>
                          {(selectedArea?.departamento || []).map((x) => (
                            <MenuItem value={x.departamento_id}>
                              {x.nome}
                            </MenuItem>
                          ))}
                        </JumboSelectField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink id='local'>
                          Local
                        </InputLabel>
                        <JumboSelectField
                          labelId='local'
                          id='local'
                          name='local'
                          value={updateInputValue(users, values, 'local')}
                          label='Local'
                          disabled={isDisabled || status == false}
                          notched
                        >
                          <MenuItem value={'Casa Transitória'}>
                            Casa Transitória
                          </MenuItem>
                          <MenuItem value={'Sede'}>Sede</MenuItem>
                          <MenuItem value={'Outro'}>Outro</MenuItem>
                        </JumboSelectField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <JumboTextField
                        fullWidth
                        name='data_inicio'
                        type='date'
                        label='Data de início'
                        sx={{ background: '#ffffff' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={isDisabled || status == false}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <div style={{ position: 'relative' }}>
                        <Select
                          id='select-two'
                          styles={customStyles}
                          options={optionsVolunteerActivities}
                          components={animatedComponents}
                          onChange={(newValue) =>
                            setActivitiesSelected(newValue.value)
                          }
                          value={optionsVolunteerActivities.filter(
                            (option) => option.value === activitiesSelected
                          )}
                          placeholder='Selecione Atividade'
                        />

                        <Typography
                          style={{
                            position: 'absolute',
                            top: '-9px',
                            left: '10px',
                            background: '#ffffff',
                            padding: '0 5px',
                            color: '#8595A6',
                            fontSize: '0.7rem',
                            fontFamily: 'NoirPro,Arial',
                          }}
                        >
                          Selecione atividade
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      {id ? (
                        <>
                          <Grid item xs={12}>
                            <Accordion
                              expanded={
                                users.status === 'ativo'
                                  ? updateInputValue(
                                      users,
                                      values,
                                      'encerrar_voluntariado'
                                    ) == 'on'
                                    ? true
                                    : false
                                  : true
                              }
                              elevation={0}
                            >
                              <AccordionSummary
                                aria-controls='panel1a-content'
                                id='panel1a-header'
                              >
                                <Stack
                                  sx={{
                                    width: '100%',
                                    textAlign: { xs: 'center', lg: 'left' },
                                  }}
                                  direction={{ xs: 'column', lg: 'row' }}
                                  justifyContent='space-between'
                                  alignItems='center'
                                  spacing={2}
                                >
                                  <Typography sx={{ fontSize: '1.05rem' }}>
                                    {users.status === 'ativo'
                                      ? 'Encerrar voluntariado?'
                                      : 'Voluntariado Encerrado'}
                                  </Typography>
                                  {users.status === 'inativo' ? (
                                    <Tooltip
                                      title={'Editar data final e/ou motivo'}
                                      arrow
                                      TransitionComponent={Zoom}
                                    >
                                      <EditIcon
                                        onClick={() => setEditInput(!editInput)}
                                      />
                                    </Tooltip>
                                  ) : undefined}

                                  {users.status === 'ativo' ? (
                                    <Stack
                                      direction='row'
                                      alignItems='center'
                                      spacing={1}
                                    >
                                      <Typography>Não</Typography>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={
                                              updateInputValue(
                                                users,
                                                values,
                                                'encerrar_voluntariado'
                                              ) == 'on'
                                                ? true
                                                : false
                                            }
                                            onChange={handleChange}
                                            name='encerrar_voluntariado'
                                            disabled={isDisabled}
                                          />
                                        }
                                        labelPlacement='start'
                                      />
                                      <Typography>Sim</Typography>
                                    </Stack>
                                  ) : undefined}
                                </Stack>
                              </AccordionSummary>
                              <AccordionDetails
                                sx={{ display: 'flex', gap: '1.5rem' }}
                              >
                                <Grid
                                  container
                                  spacing={3}
                                  alignContent={'center'}
                                >
                                  <Grid item xs={6}>
                                    <JumboTextField
                                      fullWidth
                                      name='data_fim'
                                      type='date'
                                      label='Data Final'
                                      value={updateInputValue(
                                        users,
                                        values,
                                        'data_fim'
                                      )}
                                      sx={{ background: '#ffffff' }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      disabled={
                                        isDisabled ||
                                        (isInputEditable
                                          ? isStatusDisabled
                                          : false)
                                      }
                                    />
                                  </Grid>

                                  <Grid item xs={6}>
                                    <JumboTextField
                                      fullWidth
                                      name='motivo_encerramento'
                                      label='Motivo'
                                      value={updateInputValue(
                                        users,
                                        values,
                                        'motivo_encerramento'
                                      )}
                                      disabled={
                                        isDisabled ||
                                        (isInputEditable
                                          ? isStatusDisabled
                                          : false)
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                            {values.encerrar_voluntariado == 'on' ? null : (
                              <Divider variant='middle' />
                            )}
                          </Grid>
                          <Grid item xs={12}>
                            <Accordion
                              expanded={
                                updateInputValue(
                                  users,
                                  values,
                                  'infos_usuario'
                                ) == 'on'
                                  ? true
                                  : false
                              }
                              elevation={0}
                            >
                              <AccordionSummary>
                                <Stack
                                  sx={{
                                    width: '100%',
                                    textAlign: { xs: 'center', lg: 'left' },
                                  }}
                                  direction={{ xs: 'column', lg: 'row' }}
                                  justifyContent='space-between'
                                  alignItems='center'
                                  spacing={2}
                                >
                                  <Typography sx={{ fontSize: '1.05rem' }}>
                                    Informações sobre criação e atualização do
                                    usuário
                                  </Typography>

                                  <Stack
                                    direction='row'
                                    spacing={1}
                                    alignItems='center'
                                  >
                                    <Typography>Ocultar</Typography>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          checked={
                                            updateInputValue(
                                              users,
                                              values,
                                              'infos_usuario'
                                            ) == 'on'
                                              ? true
                                              : false
                                          }
                                          onChange={handleChange}
                                          name='infos_usuario'
                                          disabled={isDisabled}
                                        />
                                      }
                                      labelPlacement='start'
                                    />
                                    <Typography>Visualizar</Typography>
                                  </Stack>
                                </Stack>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid item xs={12}>
                                  <InfosAboutCreateAndUpdate
                                    data={users}
                                    quem_criou={
                                      users?.quem_aceitou?.nome ?? '-'
                                    }
                                    quem_atualizou={
                                      users?.quem_atualizou?.nome ?? '-'
                                    }
                                  />
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </>
                      ) : null}

                      {values.encerrar_voluntariado == 'on' ? ( // verifica se o switch é true
                        <Grid item xs={12} sx={{ textAlign: 'center' }}>
                          <LoadingButton
                            color='error'
                            type='submit'
                            variant='contained'
                            size='large'
                            loading={isSubmitting}
                            disabled={
                              isDisabled ||
                              isInputFocused ||
                              status == false ||
                              values.data_fim == '' ||
                              values.data_fim == null ||
                              values.motivo_encerramento == null ||
                              values.motivo_encerramento == ''
                            }
                          >
                            Encerrar voluntariado
                          </LoadingButton>
                        </Grid>
                      ) : (
                        <Grid item xs={12} sx={{ textAlign: 'center', mt: 3 }}>
                          <LoadingButton
                            color='success'
                            type='submit'
                            variant='contained'
                            size='large'
                            sx={{ maxWidth: { md: '200px', mt: '1rem' } }}
                            loading={isSubmitting}
                            disabled={
                              isDisabled ||
                              isInputFocused ||
                              values.data_inicio == '' ||
                              values.data_inicio == null ||
                              (isInputEditable ? isStatusDisabled : false)
                            }
                          >
                            {id ? 'Atualizar' : 'Cadastrar'}
                          </LoadingButton>
                        </Grid>
                      )}
                    </Grid>
                  </> */}
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Paper>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Div sx={style}>
            <ProfileCard
              username={selectedOption?.nome}
              photo={selectedOption?.imagem_perfil}
              number={users?.codigo_voluntario_feesp}
              volunteerSince={users?.voluntario_desde}
              handleClose={handleClose}
            />
          </Div>
        </Fade>
      </Modal>
    </JumboContentLayout>
  );
};

export default VolunteerFormResume;
